{
  "nav": {
    "layers": "Couches",
    "discover": "Découvrir",
    "random": "Article aléatoire",
    "configuration": "Configuration",
    "settings": "Configuration",
    "pro": "Version PRO",
    "collections": "Collections",
    "play": "Jouer",
    "help": "Aide",
    "logout": "Déconnexion",
    "community": "Forum communautaire",
    "account": "Gérer le compte"
  },
  "auth": {
    "signIn": "Se connecter",
    "signUp": "S'inscrire",
    "signingIn": "Connexion en cours...",
    "creatingAccount": "Création du compte...",
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "username": "Nom d'utilisateur",
    "or": "ou",
    "noAccount": "Vous n'avez pas de compte ?",
    "hasAccount": "Vous avez déjà un compte ?",
    "loginFailed": "Échec de la connexion. Veuillez vérifier vos identifiants.",
    "signupFailed": "Échec de l'inscription. Veuillez réessayer."
  },
  "map": {
    "loading": "Chargement de la carte...",
    "ruler": "Souverain",
    "culture": "Culture",
    "religion": "Religion",
    "religionGeneral": "Religion générale",
    "capital": "Capitale",
    "population": "Population"
  },
  "layers": {
    "title": "Couches",
    "general": "GÉNÉRAL",
    "advanced": "Avancé",
    "area": "Zone",
    "label": "Étiquette",
    "markers": "Marqueurs",
    "epics": "Épopées",
    "migration": "Migration",
    "basemap": "Fond de carte",
    "showProvinces": "Afficher les provinces",
    "opacityByPopulation": "Opacité par population",
    "clusterMarkers": "Regrouper les marqueurs",
    "markerLimit": "Limite de marqueurs",
    "uncheckAll": "Tout décocher",
    "checkAll": "Tout cocher",
    "suggestions": "Suggestions basées sur votre appareil...",
    "markerTypes": {
      "artifact": "Artefact",
      "battle": "Bataille",
      "siege": "Siège",
      "capital": "Capitale",
      "city": "Ville",
      "castle": "Château",
      "landmark": "Point de repère",
      "military": "Militaire",
      "politician": "Politicien",
      "explorer": "Explorateur",
      "scientist": "Scientifique",
      "artist": "Artiste",
      "religious": "Religieux",
      "athlete": "Athlète",
      "unclassified": "Non classé",
      "unknown": "Inconnu"
    },
    "basemapTypes": {
      "topographic": "Topographique",
      "satellite": "Satellite",
      "light": "Light",
      "none": "Aucun"
    },
    "mapLabels": "Étiquettes de carte",
    "labelModes": {
      "historical": "Noms historiques",
      "modern": "Noms modernes",
      "both": "Les deux"
    },
    "epicTypes": {
      "wars": "Guerres",
      "empires": "Empires",
      "religion": "Religion",
      "culture": "Culture",
      "people": "Personnages",
      "other": "Autres"
    }
  },
  "settings": {
    "title": "Configuration",
    "theme": "Thème",
    "language": "Langue",
    "fullscreen": "Plein écran",
    "toggle": "Basculer",
    "fontType": "Police",
    "markerType": "Type de marqueur",
    "themes": {
      "light": "Clair",
      "dark": "Sombre",
      "luther": "Luther"
    }
  },
  "timeline": {
    "expandTimeline": "Développer la chronologie",
    "collapseTimeline": "Réduire la chronologie",
    "resetView": "Réinitialiser la vue chronologique",
    "searchEpics": "Rechercher des épopées",
    "autoplay": "Démarrer la lecture automatique",
    "stopAutoplay": "Arrêter la lecture automatique",
    "autoplayTitle": "LECTURE AUTOMATIQUE",
    "autoplaySubtitle": "CHANGE L'ANNÉE SELON LA TAILLE DU PAS",
    "startYear": "Année de début",
    "endYear": "Année de fin",
    "stepSize": "Taille du pas en années",
    "delay": "Délai en secondes",
    "repeat": "Répéter",
    "startSlideshow": "DÉMARRER LE DIAPORAMA"
  },
  "drawer": {
    "noContent": "Aucun contenu sélectionné",
    "closePanel": "Fermer le panneau",
    "provinceDataNotAvailable": "Données de province non disponibles pour cette sélection."
  },
  "common": {
    "loading": "Chargement...",
    "close": "Fermer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "edit": "Modifier",
    "delete": "Supprimer",
    "back": "Retour",
    "ad": "ap. J.-C.",
    "bc": "av. J.-C."
  }
}
